import axios from "axios";
import { APP_API_URL } from "../constants";
import { SignInRequest } from "../models/request/sign_in_request";
import axiosInstance from "../axios-instance";

const postUserLogin = async (payload: SignInRequest) => {
  const response = await axios.post(
    `${APP_API_URL}/auth/api/v1/auth/signin`,
    payload,
    {
      withCredentials: true, // Send cookies
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

const logoutUser = async () => {
  try {
    const response = await axiosInstance.post(
      `${APP_API_URL}/auth/api/v1/auth/logout`
    );
    return response.data;
  } catch (error) {
    console.error("Error during logout:", error);
    throw error;
  }
};

const postUserRegister = async (payload: any) => {
  const response = await axios.post(
    `${APP_API_URL}/auth/api/v1/auth/signup`,
    payload
  );
  return response.data;
};

const sendVerificationEmail = async (payload: any) => {
  const response = await axios.post(
    `${APP_API_URL}/auth/api/v1/auth/send-email-verification`,
    payload
  );
  return response.data;
};

const verifyEmail = async (payload: any) => {
  const response = await axios.patch(
    `${APP_API_URL}/auth/api/v1/auth/verify-email`,
    payload
  );
  return response.data;
};

const postResetPasswordEmail = async (payload: any) => {
  return await axios.post(
    `${APP_API_URL}/auth/api/v1/auth/send-password-reset-email`,
    payload
  );
};

const postResetPassword = async (payload: any) => {
  return await axios.post(
    `${APP_API_URL}/auth/api/v1/auth/reset-password`,
    payload
  );
};

export {
  postUserLogin,
  logoutUser,
  postUserRegister,
  verifyEmail,
  sendVerificationEmail,
  postResetPasswordEmail,
  postResetPassword,
};
